import { useState, useEffect } from 'react';
import { DEPENDENTES_PESQUISA } from '../../../../services/dependente';
import useFetch from '../../../../components/hooks/useFetch';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import FormExcluirDependente from './FormExcluirDependente.js';
import FormAlterarSenha from '../FormAlterarSenha.js';
import FormAlterarEmail from '../FormAlterarEmail.js';
import FormAlterarTelefone from '../FormAlterarTelefone.js';
import ModalDialog from '../../../../components/modal/ModalDialog.js';
import CardDependente from './CardDependente.js';
import { getIPAddress } from '../../../../components/utils/GetIPAddress';
import './TelaDependente.scss';

const TelaDependentes = () => {
  const { request } = useFetch();
  const [ipAddress, setIpAddress] = useState('');
  useEffect(() => {
    const fetchIPAddress = async () => {
      const ip = await getIPAddress();
      const port = window.location.port;
      setIpAddress(ip + ':' + port);
    };
    fetchIPAddress();
  }, []);
  const { request: requestDependentes, data: dadosDependentes } = useFetch();
  const location = useLocation();
  const dados = location.state;
  const navigate = useNavigate();
  const [alterei, setAlterei] = useState(false);
  const [modalAbertoExcluir, setModalAbertoExcluir] = useState(false);
  const [modalAbertoSenha, setModalAbertoSenha] = useState(false);
  const [modalAbertoEmail, setModalAbertoEmail] = useState(false);
  const [modalAbertoTelefone, setModalAbertoTelefone] = useState(false);
  const [dependenteSelecionado, setDependenteSelecionado] = useState();
  const chamaAlterarDependente = (item) => {
    const idCorreios = dados.idCorreios;
    const dados1 = [item, ipAddress, idCorreios];
    navigate('/alterarDependente', { state: dados1 });
  };
  const chamaPrincipal = () => {
    navigate('/principal');
  };
  const chamaNovoDependente = () => {
    const dados1 = [dados, ipAddress];
    navigate('/novoDependente', { state: dados1 });
  };
  const abreModalExcluir = (item) => {
    setDependenteSelecionado(item);
    setModalAbertoExcluir(true);
  };
  const abreModalSenha = (item) => {
    setDependenteSelecionado(item);
    setModalAbertoSenha(true);
  };
  const abreModalEmail = (item) => {
    setDependenteSelecionado(item);
    setModalAbertoEmail(true);
  };
  const abreModalTelefone = (item) => {
    setDependenteSelecionado(item);
    setModalAbertoTelefone(true);
  };
  useEffect(() => {
    if (dados?.idCorreios && dados?.idCorreios != '') {
      requestDependentes(DEPENDENTES_PESQUISA(dados.idCorreios));
    } else navigate('/login');
    setAlterei(false);
  }, [alterei]);
  const fechar = () => {
    setAlterei(true);
    setModalAbertoExcluir(false);
    setModalAbertoEmail(false);
    setModalAbertoTelefone(false);
  };
  return (
    <>
      <div className="conteudo dependentes">
        <h1 className="titulo-dependente">Dependentes e tutelados</h1>
        <div className="cards-container">
          {dadosDependentes?.map((item) => (
            <CardDependente
              item={item}
              key={item.idDependente}
              abreModalExcluir={abreModalExcluir}
              abreModalSenha={abreModalSenha}
              abreModalEmail={abreModalEmail}
              abreModalTelefone={abreModalTelefone}
              chamaAlterarDependente={chamaAlterarDependente}
            />
          ))}

          <button
            id="btn-adicionar-dependente"
            className="card-adicionar bg-superficie-var"
            onClick={() => chamaNovoDependente()}
          >
            <i className="ic-adicionar-circulo"></i>
            Adicionar Dependente
          </button>
        </div>
        <button className="btn-pre" onClick={() => navigate('/principal')}>
          Voltar
        </button>
      </div>
      <ModalDialog
        id="modal-excluir"
        aberto={modalAbertoExcluir}
        setAberto={setModalAbertoExcluir}
        opcaoFechar={true}
      >
        <FormExcluirDependente
          acaoCancelar={() => setModalAbertoExcluir(false)}
          acaoFechar={fechar}
          dependenteSelecionado={dependenteSelecionado}
          responsavel={dados?.idCorreios}
        />
      </ModalDialog>
      <ModalDialog
        titulo="Alterar senha"
        id="modal-senha"
        aberto={modalAbertoSenha}
        setAberto={setModalAbertoSenha}
        opcaoFechar={true}
      >
        <FormAlterarSenha
          acaoCancelar={() => setModalAbertoSenha(false)}
          acaoFechar={fechar}
          dados={dados}
          dadosDependente={dependenteSelecionado}
        />
      </ModalDialog>
      <ModalDialog
        titulo="Alterar E-mail"
        id="modal-email"
        aberto={modalAbertoEmail}
        setAberto={setModalAbertoEmail}
        opcaoFechar={true}
      >
        <FormAlterarEmail
          acaoCancelar={() => setModalAbertoEmail(false)}
          acaoFechar={fechar}
          dados={dados}
          dadosDependente={dependenteSelecionado}
        />
      </ModalDialog>
      <ModalDialog
        titulo="Alterar telefone"
        id="modal-telefone"
        aberto={modalAbertoTelefone}
        setAberto={setModalAbertoTelefone}
        opcaoFechar={true}
      >
        <FormAlterarTelefone
          acaoCancelar={() => setModalAbertoTelefone(false)}
          acaoFechar={fechar}
          dados={dados}
          dadosDependente={dependenteSelecionado}
        />
      </ModalDialog>
    </>
  );
};

export default TelaDependentes;
